<div class="col element-zoom m-0" [ngStyle]="contentStyle">
  <div class="widget-wrapper open" [ngStyle]="borderStyle" style="min-height: 100%">
    <div class="form-wrapper">
      <form [formGroup]="passwordForm" class="finxForm flex flex-col" [style.gap]="parentFormWidgetRowGap">
        @for (field of widgetConfig.attributes['field_attributes']; track field.name) {
        <div class="w-100">
          <ng-container *ngIf="field.type !== 'dropdown'">
            <div class="">
              <finxone-input
                [type]="field?.type"
                [label]="field?.label"
                [formControlName]="field?.name"
                [disableAutocomplete]="disableAutocomplete"
                [formControlInvalid]="
                  !!(
                    passwordForm.controls[field?.name]?.touched &&
                    passwordForm.controls[field?.name]?.invalid
                  )
                "
                [validationConfig]="[
                  {
                    type: field?.decision_config?.required ? 'required' : '',
                    message: getRequiredMessage(field)
                  },
                  {
                    type: 'passwordRules',
                    message:
                      customValidationMessages?.['passwordValidation'] ||
                      validationMessages.invalidInput(field?.label),
                    validatorFn: passwordRulesValidatorFn
                  }
                ]"
                [value]="passwordForm?.get(field.name)?.value ?? ''"
              >
                <span suffix #suffix class="suffix-icon">
                  <mat-icon
                    *ngIf="field.type === 'password'"
                    (click)="changePassType(field)"
                    svgIcon="pass-eye"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="field.type === 'text'"
                    (click)="changePassType(field)"
                    svgIcon="pass-eye-hide"
                  ></mat-icon>
                </span>
              </finxone-input>
            </div>
          </ng-container>
        </div>
        }
        <div class="error-wrapper" *ngIf="isError && errorMsg">
          <div class="text-error typog-xs">
            <p>{{ errorMsg }}</p>
          </div>
        </div>
        @if (isShowPasswordRule) {
        <finxone-web-frontend-password-rules
          [passwordForm]="passwordForm"
          [passwordFieldName]="'password'"
          [confirmPasswordFieldName]="'confirm_password'"
          [passwordMatchTemplate]="dataIn.attri['widgetProperties']?.['passwordMatchTemplate']"
          [passwordNoMatchTemplate]="dataIn.attri['widgetProperties']?.['passwordNoMatchTemplate']"
          (allPasswordRulesPassed)="allPasswordRulesPassed($event)"
        ></finxone-web-frontend-password-rules>
        }
      </form>
    </div>
  </div>
</div>
